import _set from 'lodash/set';
import path from 'path';
import VueI18n from 'vue-i18n';

const rLocales = require.context('./', true, /\.json$/);
const messages = rLocales.keys().reduce((m, k) => ({ ...m, [path.basename(k, '.json')]: rLocales(k) }), {});

export const locales = {
  en: {
    labels: {
      en: 'English',
      de: 'Englisch',
      es: 'Inglés',
      fr: 'Anglais',
      it: 'Inglese',
      ja: '英語',
      pl: 'Angielski',
      pt: 'Inglês',
      'pt-BR': 'Inglês',
      th: 'ภาษาอังกฤษ',
      tr: 'İngilizce',
      zh: '英语',
    },
  },
  de: {
    labels: {
      en: 'German',
      de: 'Deutsch',
      es: 'Alemán',
      fr: 'Allemand',
      it: 'Tedesco',
      ja: 'ドイツ語',
      pl: 'Niemiecki',
      pt: 'Alemão',
      'pt-BR': 'Alemão',
      th: 'ภาษาเยอรมัน',
      tr: 'Almanca',
      zh: '德语',
    },
  },
  es: {
    labels: {
      en: 'Spanish',
      de: 'Spanisch',
      es: 'Español',
      fr: 'Espagnol',
      it: 'Spagnolo',
      ja: 'スペイン語',
      pl: 'Hiszpański',
      pt: 'Espanhol',
      'pt-BR': 'Espanhol',
      th: 'ภาษาสเปน',
      tr: 'İspanyolca',
      zh: '西班牙语',
    },
  },
  fr: {
    labels: {
      en: 'French',
      de: 'Französisch',
      es: 'Francés',
      fr: 'Français',
      it: 'Francese',
      ja: 'フランス語',
      pl: 'Francuski',
      pt: 'Francês',
      'pt-BR': 'Francês',
      th: 'ภาษาฝรั่งเศส',
      tr: 'Fransızca',
      zh: '法语',
    }
  },
  it: {
    labels: {
      en: 'Italian',
      de: 'Italienisch',
      es: 'Italiano',
      fr: 'Italien',
      it: 'Italiano',
      ja: 'イタリア語',
      pl: 'Włoski',
      pt: 'Italiano',
      'pt-BR': 'Italiano',
      th: 'ภาษาอิตาลี',
      tr: 'İtalyanca',
      zh: '意大利语',
    }
  },
  ja: {
    labels: {
      en: 'Japanese',
      de: 'Japanisch',
      es: 'Japonés',
      fr: 'Japonais',
      it: 'Giapponese',
      ja: '日本語',
      pl: 'Japoński',
      pt: 'Japonês',
      'pt-BR': 'Japonês',
      th: 'ภาษาญี่ปุ่น',
      tr: 'Japonca',
      zh: '日语',
    }
  },
  pl: {
    labels: {
      en: 'Polish',
      de: 'Polnisch',
      es: 'Polaco',
      fr: 'Polonais',
      it: 'Polacco',
      ja: 'ポーランド語',
      pl: 'Polski',
      pt: 'Polonês',
      'pt-BR': 'Polonês',
      th: 'ภาษาโปแลนด์',
      tr: 'Lehçe',
      zh: '波兰语',
    }
  },
  pt: {
    labels: {
      en: 'Portuguese',
      de: 'Portugiesisch',
      es: 'Portugués',
      fr: 'Portugais',
      it: 'Portoghese',
      ja: 'ポルトガル語',
      pl: 'Portugalski',
      pt: 'Português',
      'pt-BR': 'Português',
      th: 'ภาษาโปรตุเกส',
      tr: 'Portekizce',
      zh: '葡萄牙语',
    }
  },
  'pt-BR': {
    labels: {
      en: 'Brazilian Portuguese',
      de: 'Brasilianisches Portugiesisch',
      es: 'Portugués brasileño',
      fr: 'Portugais brésilien',
      it: 'Portoghese brasiliano',
      ja: 'ブラジルポルトガル語',
      pl: 'Portugalski brazylijski',
      pt: 'Português brasileiro',
      'pt-BR': 'Português brasileiro',
      th: 'ภาษาโปรตุเกสบราซิล',
      tr: 'Brezilya Portekizcesi',
      zh: '巴西葡萄牙语',
    }
  },
  th: {
    labels: {
      en: 'Thai',
      de: 'Thailändisch',
      es: 'Tailandés',
      fr: 'Thaï',
      it: 'Tailandese',
      ja: 'タイ語',
      pl: 'Tajski',
      pt: 'Tailandês',
      'pt-BR': 'Tailandês',
      th: 'ภาษาไทย',
      tr: 'Tayca',
      zh: '泰语',
    }
  },
  tr: {
    labels: {
      en: 'Turkish',
      de: 'Türkisch',
      es: 'Turco',
      fr: 'Turc',
      it: 'Turco',
      ja: 'トルコ語',
      pl: 'Turecki',
      pt: 'Turco',
      'pt-BR': 'Turco',
      th: 'ภาษาตุรกี',
      tr: 'Türkçe',
      zh: '土耳其语',
    }
  },
  zh: {
    labels: {
      en: 'Chinese',
      de: 'Chinesisch',
      es: 'Chino',
      fr: 'Chinois',
      it: 'Cinese',
      ja: '中国語',
      pl: 'Chiński',
      pt: 'Chinês',
      'pt-BR': 'Chinês',
      th: 'ภาษาจีน',
      tr: 'Çince',
      zh: '中文',
    }
  }
};

// @link https://kazupon.github.io/vue-i18n/guide/fallback.html#explicit-fallback-with-decision-maps
const fallbackLocale = {
  default: 'en',
  // 'fr-CA': [ 'fr' ], // Automatically implied by vue-i18n!
};

export function createI18n() {
  return new VueI18n({
    locale: 'en',
    fallbackLocale,
    messages,
  });
}

const legacyTemplatesMap = {
  REGISTER_FORM_TITLE: 'auth.register.title',
  REGISTER_FORM_DESCRIPTION: 'auth.register.description',
  REGISTER_INFO_TITLE: 'auth.register.info.title',
  REGISTER_INFO_CONTENT: 'auth.register.info.content',
  // REGISTER_INFO_IMAGE: 'auth.register.image',
  LOGIN_FORM_TITLE: 'auth.login.title',
  LOGIN_FORM_DESCRIPTION: 'auth.login.description',
  // LOGIN_INFO_IMAGE: 'auth.login.image',
  REGISTER_NETWORK_PAGE_TITLE: 'onboarding.sync-connections.title',
  REGISTER_NETWORK_PAGE_DESCRIPTION: 'onboarding.sync-connections.description',
  ONBOARDING_WELCOME_TITLE: 'onboarding.introduction-video.title',
  ONBOARDING_WELCOME_DESCRIPTION: 'onboarding.introduction-video.description',
  SHARE_EMAIL_SUBJECT: 'share.email-subject',
  SHARE_EMAIL_BODY: 'share.email-body',
  SHARE_LINKEDIN_TITLE: 'share.linkedin-title',
  SHARE_LINKEDIN_BODY: 'share.linkedin-body',
  SHARE_FACEBOOK_BODY: 'share.facebook-body',
  SHARE_WHATSAPP_BODY: 'share.whatsapp-body',
  SHARE_TWITTER_BODY: 'share.twitter-body',
  EMAIL_RECRUITER_ASK_EMPLOYEE_FOR_REFERRAL_SUBJECT: 'emails.recruiter-ask-for-referral.subject',
  EMAIL_RECRUITER_ASK_EMPLOYEE_FOR_REFERRAL_BODY: 'emails.recruiter-ask-for-referral.body',
  EMAIL_RECRUITER_INVITE_EMPLOYEE_TO_PLATFORM_SUBJECT: 'emails.recruiter-invite-employee.subject',
  EMAIL_RECRUITER_INVITE_EMPLOYEE_TO_PLATFORM_BODY: 'emails.recruiter-invite-employee.body',
};

export function getLocalePreferences(company) {
  const { sitePreferences } = company || {};
  const { defaultLanguage, supportedLanguages } = sitePreferences || {};
  return {
    defaultLanguage: defaultLanguage || null,
    supportedLanguages: Array.isArray(supportedLanguages) ? supportedLanguages : [],
  };
}

export function setI18nFromAcceptLanguage(i18n, acceptLangs) {
  const { defaultLanguage, supportedLanguages } = getLocalePreferences(this.company);

  acceptLangs = Array.isArray(acceptLangs) ? acceptLangs : [];
  const fallback = (Array.isArray(acceptLangs) ? acceptLangs : []).map(accept => `${accept}`.split('-').shift());

  const locale = [ ...acceptLangs, ...fallback ].find(key => locales[key] && supportedLanguages.includes(key));
  setI18nFromLocale.call(this, i18n, locale || defaultLanguage || null);
}
export function setI18nFromLocale(i18n, locale) {
  const { supportedLanguages } = getLocalePreferences(this.company);

  if (locale && locales[locale] && (Array.isArray(supportedLanguages) && supportedLanguages.includes(locale))) {
    i18n.locale = locale;
  } else if (locale === null) {
    i18n.locale = 'en';
  }
}

export function mergeLocaleMessages(i18n, company, legacyTemplates, customMessages) {
  const overrides = {};

  try {
    const { siteBranding } = company || {};

    const variables = {
      'company-name': siteBranding.name || company.name || 'Undefined',
    };

    Object.keys(messages).forEach(lang => overrides[lang] = {
      ...overrides[lang],
      ...Object.keys(variables).reduce((l, k) => ({ ...l, [`variables.${k}`]: variables[k] }), {}),
    });
  } catch (err) {
    this.$log.error('Error building i18n variables:', err);
  }

  if (Array.isArray(legacyTemplates) && legacyTemplates.length) {
    legacyTemplates.forEach(({ key, lang, value }) => {
      if (key && legacyTemplatesMap[key] && messages[lang]) {
        try {
          if (typeof value === 'string' && value.startsWith('[') && value.endsWith(']')) {
            value = JSON.parse(value);
          }

          overrides[lang][legacyTemplatesMap[key]] = value;
        } catch (err) {
          this.$log.error('Error parsing legacy template value:', err, { lang, key, value });
        }
      }
    });
  }

  for (const key in customMessages) {
    if (Object.prototype.hasOwnProperty.call(customMessages, key)) {
      const [ lang, i18nKey, ...rest ] = key.split(':');
      const { [key]: value } = customMessages;
      if (messages[lang]) {
        try {
          this.$assert(rest.length === 0, 'Expected each i18n key to have a single ":" separator');
          if (typeof value === 'string' && value.startsWith('[') && value.endsWith(']')) {
            overrides[lang][i18nKey] = JSON.parse(value);
          } else if (Array.isArray(value) || [ 'string', 'number', 'boolean' ].includes(typeof value)) {
            overrides[lang][i18nKey] = value;
          }
        } catch (err) {
          this.$log.error('Error parsing custom i18n:', { lang, key: i18nKey, value, err });
        }
      }
    }
  }

  this.$log.debug('i18n overrides', overrides);

  /**
   * Set the locale messages by hand, since vue-i18n's default merge algorithm dislikes arrays
   */
  Object.keys(messages).filter(lang => overrides[lang]).forEach(lang => {
    const collection = i18n.getLocaleMessage(lang);

    for (const key in overrides[lang]) {
      if (overrides[lang].hasOwnProperty(key)) {
        _set(collection, key, overrides[lang][key]);
      }
    }

    i18n.setLocaleMessage(lang, collection);
  });
}



// WEBPACK FOOTER //
// ./src/i18n/index.js